/**
 * @file PremiumFaqContent.tsx
 * @description Component displaying FAQ content for premium users.
 */

import React from "react";
import GenerateContentButton from "../../components/common/GenerateContentButton";
import GeneratePlanButton from "../../components/common/GeneratePlanButton";

const PremiumFaqContent: React.FC = () => {
  return (
    <section className="relative flex flex-col items-center gap-4 p-6 mx-auto text-lg bg-base-100 rounded-3xl xl:p-12 w-fit">
      <h3 className="!mb-2 !text-4xl text-primary !font-normal">
        Cosa puoi fare
      </h3>
      <p>
        Il Premium Plan ti consente di generare un numero illimitato di
        contenuti SEO e di generare una serie di contenuti SEO per il tuo piano
        editoriale.
      </p>
      <div className="flex flex-row gap-4 mt-6">
        <GenerateContentButton />
        <GeneratePlanButton />
      </div>
    </section>
  );
};

export default PremiumFaqContent;
